import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import TempoMedioRespostaPoolStore from "../stores/TempoMedioRespostaPoolStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";

const FILTROS = ["COMPETENCIA"];

@inject("store")
@DataWrapper
@observer
export class TempoMedioRespostaPool extends Component {
    constructor(props) {
        super(props);
        this.controller = new TempoMedioRespostaPoolStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Tempo médio de resposta no pool");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                location={this.props.location}
                                controller={this.controller}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart dataKeys={["Com indicação", "Sem indicação"]}
                                        data={this.controller.dados} labelAxisX={"Fornecedor"} labelAxisY={"Tempo médio (dias)"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
